module.exports = __webpack_public_path__ + "assets/images/premium-features/sms-ec213e.png";